import React, { useState } from 'react';
import './SubjectModules.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp, faFileAlt, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
const getAllSubtopics = (subtopicsData) => Object.values(subtopicsData).flat();

const DEModules = () => {
  const modules = [
    'Module 1', 'Module 2', 'Module 3', 'Module 4', 'Module 5', 'Module 6', 'Module 7'
  ];

  const subtopicsData = {
    'Module 1': [
      { name: 'Order and Degree', path: '/de-m1-s1' },
      { name: 'Method of undetermined coefficients', path: '/de-m1-s2' },
      { name: 'Method of variation of parameters', path: '/de-m1-s3' },
      { name: 'Homogenous equation of Cauchy Euler’s type', path: '/de-m1-s4' },
      { name: 'Solving DE in Mechanical & Electrical Circuits', path: '/de-m1-s5' },
      { name: 'Summary', path: '/de-m1-s6' }
    ],
    'Module 2': [
      { name: 'Formation of pde ', path: '/de-m2-s1' },
      { name: 'Solving linear pde', path: '/de-m2-s2' },
      { name: 'Solving non-linear pde', path: '/de-m2-s3' },
      { name: 'Method of separation of variables', path: '/de-m2-s4' },
      { name: 'Summary', path: '/de-m2-s5' }
    ],
    'Module 3': [
      { name: 'Laplace transform', path: '/de-m3-s1' },
      { name: 'Properties of laplace transform', path: '/de-m3-s2' },
      { name: 'Laplace transfrom of periodic functions ', path: '/de-m3-s3' },
      { name: 'Inverse laplace transform', path: '/de-m3-s4' },
      { name: 'Summary', path: '/de-m3-s5' },

    ],
    'Module 4': [
      { name: 'Solving ode using laplace', path: '/de-m4-s1' },
      { name: 'Solving pde using laplace ', path: '/de-m4-s2' },
      { name: 'Summary', path: '/de-m4-s3' }
    ],
    'Module 5': [
      { name: 'Fourier for periodic functions', path: '/de-m5-s1' },
      { name: 'Fourier even and odd function', path: '/de-m5-s2' },
      { name: 'Fourier Half range sine and cosine series ', path: '/de-m5-s3' },
      { name: 'Parseval identity', path: '/de-m5-s4' },
      { name: 'Summary', path: '/de-m5-s5' }
    ],

    'Module 6': [
      { name: 'Fourier Transform', path: '/de-m6-s1' },
      { name: 'Properties of Fourier Transform', path: '/de-m6-s2' },
      { name: 'Convolution in Fourier Transform', path: '/de-m6-s3' },
      { name: 'Fourier Sine and Cosine Transforms', path: '/de-m6-s4' },
      { name: 'Parsevals Identity', path: '/de-m6-s5' },
      { name: 'Applications of Fourier Transform', path: '/de-m6-s6' }
    ],
    'Module 7': [
      { name: 'Z-Transform', path: '/de-m7-s1' },
      { name: 'Properties of Z-Transform', path: '/de-m7-s2' },
      { name: 'Inverse Z-Transform ', path: '/de-m7-s3' },
      { name: 'Application of Z-Transform in Difference Equations', path: '/de-m7-s4' }

    ],

  };

  const [openModule, setOpenModule] = useState(null);

  const toggleSubtopics = (module) => {
    setOpenModule(openModule === module ? null : module);
  };

  return (
    <div className="subjectbody">
      <Link to="/courses" className="return-to-course-btn">
        <FontAwesomeIcon icon={faArrowLeft} style={{ marginRight: '8px' }} />
        Back to Courses
      </Link>
      <div className="subject-header">
        <h1>DifferentialEquations</h1>
      </div>
      <div className="module-list">
        {modules.map((module) => (
          <div className="module" key={module}>
            <div className="module-header" onClick={() => toggleSubtopics(module)}>
              <span>{module}</span>
              <FontAwesomeIcon icon={openModule === module ? faChevronUp : faChevronDown} />
            </div>
            {openModule === module && (
              <ul className="subtopics">
                {subtopicsData[module].map((topic, index) => (
                  <li key={index}>
                    <span>{topic.name}</span>
                    <Link to={topic.path} className="article-link" state={{ subtopics: getAllSubtopics(subtopicsData), subjectPath: '/subject-DEModules' }}>
                      <FontAwesomeIcon icon={faFileAlt} />
                    </Link>
                  </li>
                ))}
              </ul>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default DEModules;
